import { Component, OnDestroy, OnInit } from "@angular/core";
import { IntegratedAdmissionWizardService } from "../service/integrated-admission-wizard.service";
import { IntegratedAdmissionAppointment } from "src/app/model/integrated-admission/integrated-admission-appointment";
import { ConfirmDialogService } from "src/app/services/confirm-dialog.service";
import { IntegratedAdmissionOperationDialogComponent } from "../integrated-admission-operation-dialog/integrated-admission-operation-dialog.component";
import { MatDialog } from "@angular/material";
import { Subscription } from "rxjs";
import { ReservationService } from "src/app/services/reservation.service";

@Component({
  selector: "app-integrated-admission-appointment-list",
  templateUrl: "./integrated-admission-appointment-list.component.html",
  styleUrls: ["./integrated-admission-appointment-list.component.css"],
})
export class IntegratedAdmissionAppointmentListComponent
  implements OnInit, OnDestroy
{
  appointments: IntegratedAdmissionAppointment[] = [];
  currentAppointment: IntegratedAdmissionAppointment;
  currentAppointmentSubscription: Subscription;
  readonlySubscription: Subscription;
  appointmentsSubscription: Subscription;

  finishDisabled = false;
  loading: boolean;
  readonly = false;

  constructor(
    private service: IntegratedAdmissionWizardService,
    public dialog: MatDialog,
    private confirmDialogService: ConfirmDialogService,
    private reservationService: ReservationService,
  ) {}

  ngOnDestroy(): void {
    if (this.currentAppointmentSubscription)
      this.currentAppointmentSubscription.unsubscribe();
    if (this.readonlySubscription) this.readonlySubscription.unsubscribe();
    if (this.appointmentsSubscription)
      this.appointmentsSubscription.unsubscribe();
  }

  showAddAppointment() {
    return this.service.showAddAppointment();
  }

  showPrint() {
    return this.service.showPrint();
  }

  showCopyAppointment() {
    return this.service.showCopyAppointment();
  }

  proceduresGroupedRequired() {
    return this.service.proceduresGroupedRequired;
  }

  async groupProcedures() {
    return this.service.groupProcedures();
  }

  print() {
    this.dialog.open(IntegratedAdmissionOperationDialogComponent, {
      width: "50%",
      data: this.currentAppointment.Atention,
    });
  }

  ngOnInit() {
    this.currentAppointmentSubscription =
      this.service.currentAdmissionAppointment$.subscribe((appointment) => {
        if (appointment) {
          this.currentAppointment = appointment;
        }
      });

    this.appointmentsSubscription = this.service.appointments$.subscribe(
      (appointments) => {
        this.appointments = appointments;
      },
    );

    this.readonlySubscription = this.service.currentReadOnlySubject$.subscribe(
      (readonly) => {
        this.readonly = readonly;
      },
    );
  }

  isSelected(appointment: IntegratedAdmissionAppointment) {
    return this.currentAppointment === appointment;
  }

  async finish() {
    try {
      this.finishDisabled = true;

      if (this.service.isCurrentAppointmentValid()) {
        const confirm = await this.service.getConfirmDialog().toPromise();

        if (confirm) {
          this.loading = true;
          await this.service.finish();
          this.loading = false;
        }
      }
    } finally {
      this.finishDisabled = false;
    }
  }

  async addNewCopyAppointment() {
    this.loading = true;
    await this.service.addNewCopyAppointment();
    this.loading = false;
  }

  async addNewAppointment() {
    this.loading = true;
    await this.service.addNewAppointment();
    this.loading = false;
  }

  canRemove(): boolean {
    return this.appointments.length > 1;
  }

  async remove(appointment: IntegratedAdmissionAppointment) {
    let confirm = true;
    if (appointment.Appointment.Id > 0) {
      confirm = await this.confirmDialogService
        .confirm(
          "Cancelar turno",
          "¿Estás seguro de cancelar esta parte de ingreso?",
        )
        .toPromise();

      if (confirm) {
        await this.reservationService.cancelMedicalAppointment({
          MedicalAppointmentIds: [appointment.Appointment.Id],
          MedicalAppointmentCancelReasonId: 20, // otro
          IsReschedule: false,
          Observations: "",
        });
      }
    }

    if (confirm) {
      this.service.remove(appointment);
    }
  }

  setCurrentProcedure(appointment: IntegratedAdmissionAppointment) {
    this.service.setCurrentAppointment(appointment);
  }

  getName(appointment: IntegratedAdmissionAppointment) {
    return appointment.Plan.Plan
      ? `${appointment.Plan.Entity.Name} - ${appointment.Plan.Plan.Name}`
      : "Editando...";
  }

  getNameTest(appointment: IntegratedAdmissionAppointment) {
    return`${appointment.test} - ${appointment.ValorizationEdit &&
      appointment.ValorizationEdit.ValorizationAmount &&
      appointment.ValorizationEdit.ValorizationAmount.ValorizationItemsAmount &&
      appointment.ValorizationEdit.ValorizationAmount.ValorizationItemsAmount
        .length > 0
      ? `${appointment.ValorizationEdit.ValorizationAmount.ValorizationItemsAmount[0].ValorizationItem.MedicalAppointmentProcedure.PracticeRegionName}`
      : "Editando..."}`;
  }
}
